export default __webpack_public_path__ + "static/media/g2022-16.60c418db.jpeg";